<template>
  <div class="page-wrapper downlinerep-wrapper" ref="downlineRepContainer">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="page-title emp-grp-title">
        <div class="grp-title">
          <h1 class="mb-0">Downline Reps</h1>
          <div class="" v-if="!isEnrollPrime">
            <a
              href="javascript:void(0)"
              @click.prevent="addNewDownline"
              class="new-btn"
            >
              Add New
            </a>
            <a
              href="javascript:void(0)"
              @click.prevent="
                openRegistrationLinkModel('sendEmailRegistrationLink')
              "
              style="background: #3bb54a !important"
              class="registration-link reg-link-btn"
            >
              Send Registration Link
            </a>
              <a
              href="/view-reg-log"
              style="background: #cb8531 !important"
              class="reg-link-log-btn reg-link-btn ms-2"
            >
              View Registration Link Logs
            </a>
          </div>
        </div>
        <button class="clear-search" @click="clearDownline">
          Clear Search
        </button>
      </div>
      <downline-rep-list-filter
        :filters="filterQuery"
        :active-quick-filter="activeQuickFilter"
        @onSearch="filterData"
        @quick-filter="setQuickDateFilter"
      />
      <div class="downlinedata-card">
        <!-- <div
          class="d-flex justify-content-between align-items-center top-pagination"
        >
          <page-result :rows.sync="rows" />
          <pagination :rows.sync="rows" :filters="filterQuery" />
        </div> -->
        <div class="top-pagination">
          <pagination :rows.sync="rows" :filters="filterQuery" />
        </div>
        <downline-rep-list-table
          :rows.sync="rows"
          :is-initial-load="isFirstLoad"
          :active-quick-filter="activeQuickFilter"
          @onSuccess="getAll(filterQuery)"
          @quick-filter="setQuickDateFilter"
        />
        <send-registration-link-email-modal />
        <downline-registration-contract-modal
          @redirectToRegistrationPage="redirectToRegistrationPage"
        />
        <pagination :rows.sync="rows" :filters="filterQuery" />
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import { mapGetters } from "vuex";
import Helper from "@/resource/Helper";
import DownlineRepListTable from "./partials/DownlineRepListTable";
import DownlineRepListFilter from "./partials/DownlineRepListFilter";
import sendRegistrationLinkEmailModal from "./partials/SendRegistrationLinkEmailRepModal";
import DownlineRegistrationContractModal from "./DownlineRegistrationContractModal.vue";
import isEnrollPrimeUtil from '@/utils/isEnrollPrimeUtil';


export default {
  name: "DowlineRepList",
  components: {
    DownlineRepListTable,
    DownlineRepListFilter,
    sendRegistrationLinkEmailModal,
    DownlineRegistrationContractModal,
  },
  data: () => ({
    rows: [],
    filterQuery: {
      agent_fname: "",
      agent_lname: "",
      agent_code: "",
      agent_state: "",
      agent_phone: "",
      agent_email: "",
      upline_code: "",
      upline_name: "",
      group_id: "",
      agent_status: "",
      policy_count: 0,
      agent_level: "",
      contract: "",
      product: "",
      business_name: "",
      routing_number: "",       
      account_number: "",  
      account_name: "",
      enrollment_from: "",
      enrollment_to: "",
    },
    breadcrumbItems: [{ title: "Downline Reps", active: true }],
    activeQuickFilter: null,
    isFirstLoad: true,
  }),
  computed: {
    ...mapGetters({ rep: "rep" }),
     isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    }
  },
  methods: {
    addNewDownline() {
      this.openRegistrationLinkModel("downlineContract");
      // this.redirectToRegistrationPage()
      // const route = this.$router.resolve({
      //   name: "Registration",
      //   query: { repCode: this.rep.code },
      // });
      // window.open(route.href, "_blank");
    },
    redirectToRegistrationPage() {
      const route = this.$router.resolve({
        name: "Registration",
        query: { repCode: this.rep.code },
      });
      window.open(route.href, "_blank");
    },
    openRegistrationLinkModel(modelId) {
      this.$bvModal.show(modelId);
    },
    setQuickDateFilter(range) {
      const fmt = (d) => d.toISOString().split("T")[0];
      const now = new Date();

      // Toggle off if same button clicked again
      if (this.activeQuickFilter === range) {
        this.activeQuickFilter = null;
        this.filterQuery.enrollment_from = "";
        this.filterQuery.enrollment_to = "";
        this.getAll(this.filterQuery);
        return;
      }

      this.activeQuickFilter = range;

      if (range === "all") {
        this.filterQuery.enrollment_from = "";
        this.filterQuery.enrollment_to = "";
        this.getAll(this.filterQuery);
        return;
      } else if (range === "today") {
        const t = fmt(now);
        this.filterQuery.enrollment_from = t;
        this.filterQuery.enrollment_to = t;
      } else if (range === "week") {
        const day = now.getDay();
        const monday = new Date(now);
        monday.setDate(now.getDate() - ((day + 6) % 7));
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        this.filterQuery.enrollment_from = fmt(monday);
        this.filterQuery.enrollment_to = fmt(sunday);
      } else if (range === "month") {
        const first = new Date(now.getFullYear(), now.getMonth(), 1);
        const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.filterQuery.enrollment_from = fmt(first);
        this.filterQuery.enrollment_to = fmt(last);
      }

      this.getAll(this.filterQuery);
    },
    clearDownline() {
      this.filterQuery = {
        agent_fname: "",
        agent_lname: "",
        agent_code: "",
        agent_state: "",
        agent_phone: "",
        agent_email: "",
        upline_code: "",
        upline_name: "",
        group_id: "",
        agent_status: "",
        policy_count: 0,
        agent_level: "",
        contract: "",
        product: "",
        business_name: "",
        routing_number: "",      
        account_number: "",
        account_name: "", 
        enrollment_from: "",
        enrollment_to: "",
      };
      this.activeQuickFilter = null;
      this.isFirstLoad = true;
      this.rows = [];
    },
    filterData(filters) {
      this.filterQuery = filters;
      this.getAll(this.filterQuery);
    },
    getAll(filters = []) {
      let url;
      let loader = this.$loading.show();
      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `v2/get-all-active-downline-reps?${filterUrl}`;
      } else {
        url = `v2/get-all-active-downline-reps`;
      }
      Api.get(url)
        .then((res) => {
          this.rows = res.data;
          this.isFirstLoad = false;
        })
        .catch(() => {
          this.rows = [];
          this.isFirstLoad = false;
          console.log("error");
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    if (this.$route.params.agent_status) {
      this.filterQuery.agent_status = this.$route.params.agent_status;
      this.getAll(this.filterQuery);
    }
    // No getAll() on first load without filters — buttons show instead
  },
};
</script>
<style src="@/assets/css/downline-reps.css"></style>
